import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./monthly-invoice.css";

const monthOrder = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const monthSortKey = (month) => {
  const [name, year] = (month || "").split(",");
  return parseInt(year || 0) * 100 + monthOrder.indexOf(name);
};

const formatTk = (value) => `${Number(value || 0).toFixed(2)} Tk`;

export class Datatable extends Component {
  render() {
    const { myData, history } = this.props;
    const months = [...(myData || [])].sort(
      (a, b) => monthSortKey(b.month) - monthSortKey(a.month),
    );

    return (
      <Fragment>
        {months.length === 0 ? (
          <div className="consultancy-month-empty">No months found.</div>
        ) : (
          <div className="consultancy-month-list">
            {months.map((month) => (
              <div
                className="consultancy-month-card"
                key={month.month}
                onClick={() =>
                  history.push(
                    `/business-consultancy/sourcing/invoice/${month.month}`,
                  )
                }
              >
                <div className="consultancy-month-card-header">
                  <div className="consultancy-month-card-title">
                    <i className="icofont-calendar" />
                    <span>{month.month}</span>
                  </div>
                  <div className="consultancy-month-card-header-right">
                    <span className="consultancy-month-card-badge">
                      {month.invoiceCount || 0} invoice
                      {month.invoiceCount === 1 ? "" : "s"}
                    </span>
                    <button
                      type="button"
                      className="consultancy-month-card-view"
                      onClick={(e) => {
                        e.stopPropagation();
                        history.push(
                          `/business-consultancy/sourcing/invoice/${month.month}`,
                        );
                      }}
                    >
                      View <i className="fa fa-angle-right" />
                    </button>
                  </div>
                </div>
                <div className="consultancy-month-card-stats">
                  <div className="consultancy-month-stat">
                    <span className="consultancy-month-stat-label">
                      Total Bill
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalBill)}
                    </span>
                  </div>
                  <div className="consultancy-month-stat">
                    <span className="consultancy-month-stat-label">
                      Total Paid
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalPaid)}
                    </span>
                  </div>
                  <div className="consultancy-month-stat">
                    <span className="consultancy-month-stat-label">
                      Total Buying Cost
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalBuyingCost)}
                    </span>
                  </div>
                  <div className="consultancy-month-stat">
                    <span className="consultancy-month-stat-label">
                      Total Agent Profit
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalAgentProfit)}
                    </span>
                  </div>
                  <div className="consultancy-month-stat">
                    <span className="consultancy-month-stat-label">
                      Total Profit
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalProfit)}
                    </span>
                  </div>
                  <div className="consultancy-month-stat consultancy-month-stat--accent">
                    <span className="consultancy-month-stat-label">
                      Total Zapai Profit
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalZapaiProfit)}
                    </span>
                  </div>
                  <div className="consultancy-month-stat consultancy-month-stat--refund">
                    <span className="consultancy-month-stat-label">
                      Refund Given
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalRefundGiven)}
                    </span>
                  </div>
                  <div className="consultancy-month-stat consultancy-month-stat--refund-taken">
                    <span className="consultancy-month-stat-label">
                      Refund Taken
                    </span>
                    <span className="consultancy-month-stat-value">
                      {formatTk(month.totalRefundTaken)}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Fragment>
    );
  }
}

export default connect(null, {})(Datatable);
